(() => {
  if (customElements.get('covalt-backorder-order-properties')) return;

  const instances = new Set();
  const dateFormatter = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Monterrey', year: 'numeric', month: '2-digit', day: '2-digit'
  });
  const today = () => {
    const parts = dateFormatter.formatToParts(new Date());
    const part = (name) => parts.find((item) => item.type === name).value;
    return `${part('year')}-${part('month')}-${part('day')}`;
  };
  const refresh = () => instances.forEach((instance) => instance.update());

  class BackorderOrderProperties extends HTMLElement {
    connectedCallback() {
      if (this.form) return;
      this.form = this.closest('form');
      this.backorderInput = this.querySelector('[name="properties[_covalt_backorder]"]');
      this.dateInput = this.querySelector('[name="properties[_covalt_dispatch_date]"]');
      if (!this.form || !this.backorderInput || !this.dateInput) return;

      try {
        const variants = JSON.parse(this.querySelector('[data-backorder-variants]').textContent);
        this.variants = new Map(variants.map((variant) => [String(variant.id), variant]));
      } catch {
        this.variants = new Map();
      }

      this.scope = this.form.closest('[data-section-type]') || this.form;
      this.onClick = (event) => {
        if (event.target.closest('[data-action="add-to-cart"]')) this.update();
      };
      this.onSubmit = () => this.update();
      this.onInput = (event) => {
        if (event.target.name === 'id' || event.target.name === 'quantity') this.update();
      };
      this.onVariantChanged = (event) => {
        if (event.target.contains(this)) this.update(event.detail?.variant?.id ?? '');
      };

      this.form.addEventListener('click', this.onClick, true);
      this.form.addEventListener('submit', this.onSubmit, true);
      this.form.addEventListener('change', this.onInput);
      this.form.addEventListener('input', this.onInput);
      this.scope.addEventListener('variant:changed', this.onVariantChanged);
      instances.add(this);
      this.update();
    }

    disconnectedCallback() {
      if (!this.form) return;
      this.form.removeEventListener('click', this.onClick, true);
      this.form.removeEventListener('submit', this.onSubmit, true);
      this.form.removeEventListener('change', this.onInput);
      this.form.removeEventListener('input', this.onInput);
      this.scope?.removeEventListener('variant:changed', this.onVariantChanged);
      instances.delete(this);
      this.form = null;
    }

    update(variantId) {
      if (!this.form || !this.backorderInput || !this.dateInput) return;
      const selectedId = variantId === undefined ? this.form.elements.namedItem('id')?.value : variantId;
      const variant = this.variants.get(String(selectedId));
      const dispatchDate = this.dataset.dispatchDate || '';
      const validDate = /^\d{4}-\d{2}-\d{2}$/.test(dispatchDate)
        && !Number.isNaN(Date.parse(`${dispatchDate}T00:00:00Z`))
        && new Date(`${dispatchDate}T00:00:00Z`).toISOString().slice(0, 10) === dispatchDate;
      const eligible = Boolean(validDate && dispatchDate >= today() && variant
        && variant.available === true && variant.inventory_policy === 'continue'
        && Number.isFinite(variant.inventory_quantity) && variant.inventory_quantity <= 0
        && variant.requires_shipping === true);

      this.backorderInput.value = eligible ? 'true' : '';
      this.dateInput.value = eligible ? dispatchDate : '';
      this.backorderInput.disabled = !eligible;
      this.dateInput.disabled = !eligible;
    }
  }

  customElements.define('covalt-backorder-order-properties', BackorderOrderProperties);
  document.addEventListener('visibilitychange', refresh);
  window.addEventListener('pageshow', refresh);
  window.setInterval(refresh, 60000);
})();
